export default {
  header: 'Welcome to Your Financial Health Toolkit!',
  subheader: {
    title: 'Many homeowners have experienced financial challenges. Job loss, illness, or unexpected expenses can stand in the way of your financial goals.',
    description: "The Center's Homeowner Financial Toolkit supports homeowners in understanding and addressing financial issues to build a better future. The toolkit is an action-oriented approach that empowers homeowners to set financial goals and reach them. Start with our Financial Health Check-up and we'll recommend resources to support your financial well-being."
  }
};
